<template>
  <div>
    <!-- eslint-disable-next-line vue/no-v-for-template-key -->
    <template v-for="dimensionScore in props.data.bookingProcessScores" :key="dimensionScore.label">
      <div v-if="dimensionScore.value > 0" class="my-4">
        <div class="flex justify-between">
          {{ dimensionScore.label }}

          <div class="text-tiny font-semibold">
            {{ formatNumber(dimensionScore.value) }}
          </div>
        </div>
        <div class="mt-1">
          <!-- score is between 0 and 5 -->
          <ProgressBar
            :progress="dimensionScore.value / 5"
            size="small"
            color="green"
          />
        </div>
      </div>
    </template>

    <div class="text-xs text-grey-600 mt-6">
      Verified reviews come from Tagvenue users. All reviews are checked by our team to uphold our trust and safety standards.
    </div>
  </div>
</template>

<script setup>

import ProgressBar from '@/components/Ui/ProgressBar.vue';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});

const formatNumber = (number) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(number);
};
</script>
